/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    SgSptWinterSportsExclusionModalHeader: {
        id: 'qnb.spt.SgSptWinterSportsExclusionModal.Header.Msg',
        defaultMessage: 'Winter Sports Cover'
    },
    SgSptWinterSportsExclusionModalContinueBtn: {
        id: 'qnb.spt.SgSptWinterSportsExclusionModal.ContinueBtn',
        defaultMessage: 'Continue'
    },
    SgSptWinterSportsExclusionModalParagraph: {
        id: 'qnb.spt.SgSptWinterSportsExclusionModal.Paragraph',
        defaultMessage: 'Unfortunately, the following travellers have been excluded from Winter Sports Cover due to their declared medical conditions. They will benefit from all other aspects of the cover.'
    },
    SgSptWinterSportsExclusionModalAllExcludedParagraph: {
        id: 'qnb.spt.SgSptWinterSportsExclusionModal.AllExcludedParagraph',
        defaultMessage: 'Unfortunately, all the travellers have been excluded from Winter Sports Cover due to their declared medical conditions. They will benefit from all other aspects of the cover.'
    }
});
